// 네이티브 <input type="date">는 크롬에서 달력 아이콘을 눌러야 피커가 뜨고, yyyy-mm-dd 텍스트
// 부분을 클릭하면 그냥 그 세그먼트에 커서만 놓인다(사용자 피드백: "날짜 부분을 클릭해도 피커가
// 뜨면 좋겠어"). showPicker()로 클릭 위치와 무관하게 항상 달력이 뜨게 한다.
export function bindDatePickerClick(input: HTMLInputElement): void {
  input.addEventListener("click", () => {
    if (typeof input.showPicker === "function") {
      try {
        input.showPicker();
      } catch {
        // 사용자 제스처 타이밍 등으로 실패해도 조용히 무시 — 기본 클릭 동작은 그대로 유지된다.
      }
    }
  });
}
